import loader from '@/assets/icons/loader.svg'

export const LoadingSpinner = ({
  className
}: {
  className?: string
}) => (
  <img className={`animate-spin ${className}`} src={loader} alt="" />
)
